'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import utils from 'services/utils';
import moment from 'moment';
import _ from 'underscore';
import classNames from 'classnames';

import 'styles/Calendar.scss';


const now = moment();

const propTypes = {
    month: PropTypes.object,
    formats: PropTypes.object,
    currentDate: PropTypes.object,
    dayFormatter: PropTypes.func.isRequired,
};

const defaultProps = {
    formats: {},
    currentDate: null,
};

class Calendar extends React.Component {

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
            weekdays: utils.getWeekdayNames(),
        };
    }    

    handleDayClick(day, event) {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();

        var date = this.props.month.clone().add(day - 1, "days");
        this.props.handleDayClickCallback(date, event);
    }

    render() {
        var Component = this.props.dayFormatter;
        var month = this.props.month;
        var daysInMonth = month.daysInMonth();
        var firstDayOfMonth = month.day();

        var days = _.range(1, daysInMonth + 1);

        var today = moment();

        let range = firstDayOfMonth - 1;
        if (firstDayOfMonth === 0) {  // week starts on Sunday
            range = 6;
        }

        _.each(_.range(range), function () {  //firstDayOfMonth - 1, make adjustment for Monday as first day of week.
            days.unshift(null); //add empty "days" to the start of the first week
        });

        var groupedDays = utils.createGroupedArray(days, 7);


        var _this = this;
        var dayRows = groupedDays.map(function (group, i) {
            var weekDays = group.map(function (day, j) {
                var currentSelected = _this.props.currentDate && _this.props.currentDate.date() === day && _this.props.currentDate.month() === _this.props.month.month() && _this.props.month.year() === _this.props.currentDate.year();
                return (
                    <Component 
                        key={"day" + j + i}
                        day={{
                            day,
                            formats: _this.props.formats[day],
                        }}
                        handleDayClickCallback={_this.handleDayClick}
                        today={_this.props.month.month() === today.month() && _this.props.month.year() === today.year() && day === today.date()}
                        currentSelection={currentSelected}
                        isWeekend={(j === _.indexOf(_this.state.weekdays, 'Sat') || j === _.indexOf(_this.state.weekdays, 'Sun'))}
                    />
                );
            });
            return (
                <div className="week" key={"week" + i}>{weekDays}</div>
            );
        });


        return (
            <div>
                <div className="header-days">
                    {this.state.weekdays.map(function (day) {
                        var classes = classNames(
                            'calendar-day', {
                                weekend: day === 'Sat' || day === 'Sun',
                            }
                        );
                        return <span className={classes} key={day}>{day}</span>;
                    })}
                </div>
                <div className="row-days">
                    {dayRows}
                </div>
            </div>
        );
    }
}

Calendar.propTypes = propTypes;
Calendar.defaultProps = defaultProps;
export default Calendar; 